
import { Box } from "@mui/material";
import { useState } from "react";

export default function LangDropdown(props) {
  const [open, setOpen] = useState(false);
  return <Box sx={{
    height: '50px',
  }}>
    <Box sx={{
      borderRadius: 25,
      gap: '5px',
      display: 'grid',
      height: '40px',
      overflow: 'hidden',
      transition: 'all 0.4s',
      ...(open && {
        height: props.children.length * 40 + 5,
        boxShadow: '0px 0px 0 4px #00000021',
        background: '#00000021',
      }),
      "& > *": {
        margin: '0 !important',
      }
    }} onClick={() => setOpen(!open)}>
      {
        props.children[0].props.className === "disabled" ? [...props.children].reverse() : props.children
      }
    </Box>
  </Box>
}